import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
const GetToken = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isLogout = params.get("logout") === "true";
  const { data }: any = useQuery({
    queryKey: ["login"],
    enabled: false,
  });
  
  // Also check localStorage for persisted login data
  const getPersistedData = () => {
    try {
      const persisted = localStorage.getItem("teacher-portal");
      if (persisted) {
        const parsed = JSON.parse(persisted);
        if (parsed?.clientState?.queries) {
          const loginQuery = parsed.clientState.queries.find((q: any) => q.queryKey?.[0] === "login");
          if (loginQuery?.state?.data?.data?.access) {
            return loginQuery.state.data.data;
          }
        }
      }
    } catch (e) {
      // Ignore parsing errors
    }
    return null;
  };
  
  const persistedData = getPersistedData();
  const loginData = data?.data || persistedData;
  
  const getAccess = () => {
    if (isLogout) return null;
    return loginData?.access || null;
  };

  return {
    token: getAccess(),
    isLoggedIn: !!getAccess(),
    isSchool: isLogout ? false : (loginData?.user?.is_school || false),
    id: loginData?.user?.id,
    school_logo: loginData?.user?.school_logo,
    full_name: loginData?.user?.is_teacher ? loginData?.user?.full_name : null,
    school_name: loginData?.user?.is_school ? loginData?.user?.school_name : null,
  };
};

export default GetToken;
